import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './sov-header-page.scss';

import type { SOVReportType } from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('modules/insights/sov/shared/sov-shared.i18n.json'));

type Props = {
  reportType: SOVReportType
};

const COLLABARY_MSG_KEY = 'collabary_common';
const SHARED_MSG_KEY = 'sov_shared';

const SOVHeaderPage = (
  {
    reportType
  }: Props
): JSX.Element => (
  <div className="sov-header-page">
    <div className="sov-header-page__icon">
      <SVGDynamicIcon
        name={`${reportType}-custom-fg`}
        width={24}
        height={24}
        customColor="grey"
      />
    </div>
    <div className="sov-header-page__text">
      {__t(`${COLLABARY_MSG_KEY}.social.${reportType}`)}
      &nbsp;{__t(`${SHARED_MSG_KEY}.labels.share_of_voice`)}
    </div>
  </div>
);

export default SOVHeaderPage;
